import type { ReactNode } from "react";

// Each flag is its own file, fetched only when shown. The package stylesheet inlines all 271 flags
// and blocked first render with 84 KB gzip of CSS.
const flagUrls = import.meta.glob<string>("/node_modules/flag-icons/flags/4x3/*.svg", {
  query: "?url&no-inline",
  import: "default",
  eager: true,
});

interface FlagIconsFlagProps {
  region: string;
  size: number;
}

/** Owns the file layout of the flag-icons package. */
export function FlagIconsFlag({ region, size }: FlagIconsFlagProps): ReactNode {
  const url = flagUrls[`/node_modules/flag-icons/flags/4x3/${region}.svg`];
  if (!url) {
    return null;
  }

  return (
    <img
      src={url}
      width={size}
      height={size * 0.75}
      alt=""
      aria-hidden="true"
      className="inline-flex shrink-0"
      data-testid="language-indicator"
    />
  );
}
